import React, { useState, useCallback, useEffect } from 'react'
import Spiner from '../../components/General/Spiner'
import VerisChatAI from '../../components/General/VerisChatAI'
import logoVeris from '../../assets/Logo.png'

const ChatAI = () => {
    const [spiner, setSpiner] = useState(false)
    const [message, setMessage] = useState('')
    const [initMessage, setInitMessage] = useState(false)

    const getGroupUser = useCallback(async () => {
        setSpiner(true)
        // Aquí iría tu lógica de carga de datos, etc.
        setSpiner(false)
    }, [])

    useEffect(() => {
        getGroupUser()
    }, [getGroupUser])

    const handleSendMessage = () => {
        // Lógica para enviar el mensaje
        localStorage.setItem('isChatActive', true)
        setInitMessage(true)
    }

    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="chat-ai-wrapper">
                        {spiner && <Spiner />}
                        <div className="chat-ai-container-custom">
                            <div className="chat-ai-header-custom">
                                <img src={logoVeris} alt="Veris Chat AI Logo" className="chat-ai-logo-custom" />
                            </div>

                            {
                                !initMessage && !localStorage.getItem('isChatActive')
                                    ?
                                    <div>

                                        <h1 className="chat-ai-greeting-custom">Hola, {localStorage.getItem('userName')}</h1>
                                        <h2 className="chat-ai-subtitle-custom">¿En qué podemos ayudarte?</h2>
                                        <br /><br />
                                        <div className="chat-ai-features-custom">
                                            <div className="chat-ai-section-custom">
                                                <i className="nav-icon fas fa-lightbulb chat-ai-icon-custom"></i>
                                                <h3 className="chat-ai-title-custom">Ejemplos</h3>
                                                <ul className="chat-ai-list-custom">
                                                    <li>¿Cómo puedo crear y mantener un presupuesto mensual eficaz?</li>
                                                    <li>¿Cuál es la diferencia entre acciones, bonos y fondos de inversión?</li>
                                                </ul>
                                            </div>
                                            <div className="chat-ai-section-custom">
                                                <i className="nav-icon fas fa-tasks chat-ai-icon-custom"></i>
                                                <h3 className="chat-ai-title-custom">Capacidades</h3>
                                                <ul className="chat-ai-list-custom">
                                                    <li>Recuerda lo que dijo el usuario anteriormente en la conversación.</li>
                                                    <li>Permite al usuario proporcionar correcciones de seguimiento.</li>
                                                </ul>
                                            </div>
                                            <div className="chat-ai-section-custom">
                                                <i className="nav-icon fas fa-question-circle chat-ai-icon-custom"></i>
                                                <h3 className="chat-ai-title-custom">Temas</h3>
                                                <ul className="chat-ai-list-custom">
                                                    <li>Preguntas sobre Analítica, presupuestos, Gestión.</li>
                                                    <li>Cualquier tema de su interés.</li>
                                                </ul>
                                            </div>
                                        </div>
                                        {/* Barra de chat */}
                                    </div>
                                    :
                                    <div>
                                        <VerisChatAI message={message} />
                                        <br />
                                    </div>

                            }

                            {
                                !initMessage && !localStorage.getItem('isChatActive')
                                && (

                                    <div className="chat-input-wrapper">
                                        <input
                                            type="text"
                                            className="chat-input"
                                            placeholder="Escribe una pregunta"
                                            value={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                        />
                                        <div className="chat-input-icons">
                                            <button className="chat-send-button" onClick={handleSendMessage}>
                                                Enviar
                                            </button>
                                        </div>
                                    </div>
                                )
                            }

                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default ChatAI
